<div class="bg-white rounded shadow-lg overflow-hidden max-w-[90%] max-h-[85dvh] m-auto flex flex-col min-w-[32rem]">
  <!-- Modal header -->
  <div class="px-5 py-3 border-b bg-white border-slate-200 sticky top-0">
    <div class="flex justify-between items-center">
      <div class="font-semibold text-primary-100">Imprimir Ticket(s)</div>
      <button (click)="closeprintTicketsOverlay();" class="text-slate-400 hover:text-slate-500 close-overlay-directive">
        <div class="sr-only">Cerrar</div>
        <svg class="w-4 h-4 fill-current">
          <path d="M7.95 6.536l4.242-4.243a1 1 0 111.415 1.414L9.364 7.95l4.243 4.242a1 1 0 11-1.415 1.415L7.95 9.364l-4.243 4.243a1 1 0 01-1.414-1.415L6.536 7.95 2.293 3.707a1 1 0 011.414-1.414L7.95 6.536z"></path>
        </svg>
      </button>
    </div>
  </div>

  <!-- Modal content -->
  <div class="px-5 py-4 overflow-auto flex-1 h-full flex flex-col justify-center">
    <div class="text-sm">
      <div class="font-medium text-slate-800 mb-3">
        <div class="col-span-12 lg:col-span-12 xl:col-span-12 2xl:col-span-12">
          <app-input-field-maker [formGroup]="saleForm" [controlName]="'selectedPrinter'"
                                 [label]="'Selecciona una impresora instalada'" [inputType]="'ngselect'"
                                 [generalError]="'Por favor, selecciona una impresora instalada'" [items]="printers"
                                 [bindValue]="'printer'" [bindLabel]="'printer'"></app-input-field-maker>
        <!--          <div id="installedPrinters">-->
        <!--            <label for="printer">Selecciona una impresora instalada:</label>-->
        <!--            <select name="printer" id="printer" [(ngModel)]="selectedPrinter">-->
        <!--              <option disabled [ngValue]="undefined">Selecciona impresora</option>-->
        <!--              <option *ngFor="let printer of printers" [ngValue]="printer">{{ printer }}</option>-->
        <!--            </select>-->
        <!--          </div>-->
      </div>
    </div>
  </div>

  <!-- Modal footer -->
  <div class="px-4 border-t bg-pearl border-slate-200 sticky bottom-0" style="padding-top: 1rem">
    <div class="flex flex-wrap justify-end space-x-2">
      <button (click)="closeprintTicketsOverlay();" class="btn-sm border-slate-200 hover:border-slate-300 text-slate-600 close-overlay-directive">Cerrar</button>
      <button (click)="doPrintZPL();" class="btn-sm hover:bg-gl-blue-hover bg-gl-blue text-white">Imprimir</button>
    </div>
  </div>
</div>
